import { createMediaQueryList } from '../utils/_breakpoints';

import wishlist from '../utils/_wishlist';
import { getDataProperty } from '../utils/_domFunctions';

const domFunctions = require('../utils/_domFunctions');
const urlUtils = require('../utils/_urlUtils');
const dyHelpers = require('../utils/_dyHelpers');

/**
 * Resize quantity selector to not exceed max quantity that can be ordered
 * @param {Node} quantitySelector quantity selector
 * @param {Int} maxQuantity max quantity
 */
function resizeQuantityOptions(quantitySelector, maxQuantity) {
    const options = quantitySelector.children;
    if (options.length > maxQuantity) {
        let option = options.item(maxQuantity);
        while (option) {
            domFunctions.removeNode(option);
            option = options.item(maxQuantity);
        }
    } else {
        while (options.length < maxQuantity) {
            const newOption = document.createElement('option');
            newOption.innerHTML = options.length + 1;
            quantitySelector.appendChild(newOption);
        }
    }
}

class oCart extends HTMLDivElement {
    constructor() {
        super();
        this.cartTotals = {
            numberOfItems: this.querySelector('.number-of-items'),
            shippingCost: this.querySelectorAll('.shipping-cost'),
            taxTotal: this.querySelector('.tax-total'),
            grandTotal: this.querySelector('.grand-total'),
            subTotal: this.querySelector('.cart-sub-total--price'),
            orderDiscount: this.querySelector('.order-discount'),
            orderDiscountTotal: this.querySelector('.order-discount-total'),
            shippingDiscount: this.querySelector('.shipping-discount'),
            couponsAndPromos: this.querySelector('.coupons-and-promos'),
            approachingDiscounts: this.querySelector('.approaching-discounts'),
        };
        this.bonusProduct = this.querySelector('.bonus-product');
        this.checkoutBtn = this.querySelector('.checkout-btn');
        this.mobileUpperCartBtn = document.querySelector('.checkout-btn-mobile');
        this.productLineItems = this.querySelectorAll('[data-component-product]');
        this.error = this.querySelector('[data-component-error]');
        this.shippingMethods = this.querySelectorAll('[data-component-shipping-methods]');
        this.couponCodeField = this.querySelector('.coupon-code-field');
        this.removeCouponModalTrigger = document.querySelectorAll('.remove-coupon');
        this.removeCouponConfirmationBtn = document.querySelector('.delete-coupon-confirmation-btn');
        this.removeCouponPopin = document.querySelector('#m-popin-remove-coupon');
        this.promoCodeField = this.querySelector('#couponCode');
        this.promoCodeLabel = this.querySelector('label[for="couponCode"]');
        this.promoCodeWrapper = this.promoCodeField ? this.promoCodeField.closest('.input-wrapper') : null;
        this.promoForm = this.querySelector('[data-component-promo]');
        this.paypalCheckButton = this.querySelectorAll('.paypal-check-button');
        this.gtmPaymentOptions = this.querySelectorAll('[data-gtm-payment-option]');
        this.productQuantity = getDataProperty(this, 'minicartQuantity', 'number', NaN);
        this.productListSections = {
            inStock: document.getElementById('product-list-instock'),
            limited: document.getElementById('product-list-limited'),
            oos: document.getElementById('product-list-oos'),
        };
        this.paypalButtonLocations = this.querySelectorAll('.paypal-location');
        this.paypalButton = document.querySelector('#paymentMethodsList');
        this.desktopCheckoutButton = this.querySelector('.desktop-checkout-buttons [data-components-cart-valid]');
        this.mobileCheckoutButton = this.querySelector('.mobile-checkout-buttons [data-components-cart-valid]');
        if (this.promoForm) {
            this.couponMissingError = this.promoForm.querySelector('.coupon-missing-error');
            this.couponErrorContainer = this.promoForm.querySelector('.coupon-error');
            this.couponErrorMessage = this.promoForm.querySelector('.coupon-error-message');
            this.couponFieldReductionAmount = this.promoForm.querySelector('span.coupon-field-reduction-amount');
        }

        this.isMinicart = ('minicart' in this.dataset); // Is on cart page or for minicart

        this.productToDelete = {
            uuid: '',
            pid: '',
            actionUrl: '',
        };

        this.mqlDesktop = createMediaQueryList('md');
        this.currentBreakpoint;

        // this bindings
        this.updateTax = this.updateTax.bind(this);
        this.bindMobileUpperBtnToLowerBtn = this.bindMobileUpperBtnToLowerBtn.bind(this);
        this.setupRemoveCouponData = this.setupRemoveCouponData.bind(this);
        this.removeCoupon = this.removeCoupon.bind(this);
        this.addEventPromoSubmit = this.addEventPromoSubmit.bind(this);
        this.setPromoCodeValidation = this.setPromoCodeValidation.bind(this);
        this.closeMiniCart = this.closeMiniCart.bind(this);
        this.emptyMiniCart = this.emptyMiniCart.bind(this);
        this.onDeleteProduct = this.onDeleteProduct.bind(this);
        this.onCloseMinicart = this.onCloseMinicart.bind(this);
        this.onResizeWindow = this.onResizeWindow.bind(this);

        this.addPaypalExpress();
    }

    connectedCallback() {
        this.addEventsProductLineItems();
        this.addEventShippingMethods();
        this.addEventPostalCodeTax();
        this.addEventPromoSubmit();
        this.bindMobileUpperBtnToLowerBtn();
        wishlist.activateWishlistHeartButtons();

        if (this.paypalCheckButton.length) {
            this.paypalCheckButton.forEach((paypalCheckButton) => {
                paypalCheckButton.addEventListener('click', () => {
                    this.error.textContent = paypalCheckButton.dataset.paypalErrorMsg;
                    if (!this.mqlDesktop.matches) {
                        this.error.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                });
            });
        }

        if (!this.isMinicart) {
            document.addEventListener('click', this.setupRemoveCouponData);
            this.removeCouponConfirmationBtn.addEventListener('click', this.removeCoupon);
            this.onResizeWindow();
            this.mqlDesktop.addEventListener('change', this.onResizeWindow.bind(this));
            // Mobile button is out of the cart form, so we dispatch the click event to the desktop button that is in the form
            this.mobileCheckoutButton.addEventListener('click', () => {
                this.desktopCheckoutButton.dispatchEvent(new Event('click'));
            });
        } else {
            document.addEventListener('oSidebar:close', this.onCloseMinicart);
            this.currentDyData = dyHelpers.setDyRecommendationContext();
            this.gtmPaymentOptions.forEach((paymentOption) => {
                const paymentOptionValue = paymentOption.dataset.gtmPaymentOption;
                paymentOption.addEventListener('click', () => { this.gtmPaymentOptionMinicart(paymentOptionValue); });
            });
            // This is used to track click inside iframe. When clicking on PayPal button, the iframe capture the click
            // And it is not possible to capture it before. When we click inside the iframe, the blur event is triggered in
            // the window, we wait one frame and we check what was the last element clicked, here the iframe. We can now
            // verify if the iframe clicked is the paypal one. Stackoverflow thread : https://stackoverflow.com/questions/2381336/detect-click-into-iframe-using-javascript
            window.addEventListener('blur', () => {
                setTimeout(() => {
                    const { activeElement } = document;
                    if (activeElement && activeElement.tagName === 'IFRAME') {
                        const paypalButton = activeElement.closest('[data-gtm-payment-paypal]');
                        if (paypalButton) {
                            const paymentOptionValue = paypalButton.dataset.gtmPaymentPaypal;
                            this.gtmPaymentOptionMinicart(paymentOptionValue);
                        }
                    }
                });
            });
            // If a product is Offline, set the new value to the mini-cart icon in the same page
            // When the user is gonna change page, this will be set with the controller
            if (!Number.isNaN(this.productQuantity)) {
                document.dispatchEvent(new CustomEvent('oNavigation:updateCartCount', {
                    detail: {
                        productCount: this.productQuantity,
                    },
                }));
            }
        }
    }

    disconnectedCallback() {
        if (this.isMinicart) {
            document.removeEventListener('oSidebar:close', this.onCloseMinicart);
        }
    }

    movePaypalButton(destination) {
        if (this.paypalButton) {
            this.paypalButton.classList.remove('d-none');
            destination.prepend(this.paypalButton);
        }
    }

    onResizeWindow() {
        const isDesktop = this.mqlDesktop.matches;
        if (this.paypalButtonLocations.length !== 2) {
            return;
        }
        this.movePaypalButton(isDesktop ? this.paypalButtonLocations[1] : this.paypalButtonLocations[0]);
    }

    gtmPaymentOptionMinicart(paymentOption) {
        document.dispatchEvent(new CustomEvent('gtm:pushEvent', {
            detail: {
                usePageView: true,
                eventName: 'checkout_mini_cart',
                attributes: {
                    checkout_option: paymentOption,
                },
            },
        }));
    }

    makeRemoveProductModal() {
        // Clone remove product modal template
        const removeProductModalTemplate = this.querySelector('template[data-remove-product-modal]');
        if (!removeProductModalTemplate) {
            throw new Error('Missing template for remove product modal');
        }
        const removeProductModalEl = removeProductModalTemplate.content
            .querySelector('[is="m-popin"]')
            .cloneNode(true);

        // Setup close callback
        removeProductModalEl.addEventListener('close', () => { removeProductModalEl.remove(); });

        // Setup delete button ("yes" button)
        removeProductModalEl
            .querySelectorAll('[data-component-confirm-delete]')
            .forEach((el) => { el.addEventListener('click', this.onDeleteProduct); });

        // Toggle display
        document.body.appendChild(removeProductModalEl);
        // TODO: Find a better fix than setTimeout
        // Execute in the next event cycle to let the webcomponent load well; (https://developer.mozilla.org/en/docs/Web/API/setTimeout)
        setTimeout(() => {
            // TODO: modify popin to remove "toggling" behavior
            removeProductModalEl.togglePopin();
        });
    }

    /*
        This adds the coupon code and coupon uuid in the remove coupon confirmation popin
        the data is stored in the 'yes' button dataset like this : <button data-code="EXTRA30" data-uuid="5ab660eebbf024c9a08b4dfba4">
        to make it ready to call Cart-RemoveCoupon SFRA Endpoint
    */
    setupRemoveCouponData(e) {
        if (e && e.currentTarget && e.currentTarget.activeElement && e.currentTarget.activeElement.classList.contains('remove-coupon')) {
            const currentRemoveCouponBtn = e.currentTarget.activeElement;

            this.removeCouponConfirmationBtn = document.querySelector('.delete-coupon-confirmation-btn');
            this.removeCouponConfirmationBtn.dataset.code = currentRemoveCouponBtn.dataset.code;
            this.removeCouponConfirmationBtn.dataset.uuid = currentRemoveCouponBtn.dataset.uuid;
        }
    }

    /*
        This sets the visual validity of the input (green / red)
        boolean = true means valid
    */
    setPromoCodeValidation(boolean) {
        if (boolean) {
            this.couponErrorContainer.setAttribute('hidden', true);
            this.promoCodeWrapper.classList.add('valid');
            this.promoCodeWrapper.classList.remove('error');
            this.promoCodeLabel.classList.remove('error');
            this.promoCodeLabel.classList.add('valid');
        } else {
            this.couponErrorContainer.removeAttribute('hidden');
            this.promoCodeWrapper.classList.remove('valid');
            this.promoCodeWrapper.classList.add('error');
            this.promoCodeLabel.classList.add('error');
            this.promoCodeLabel.classList.remove('valid');
        }
    }

    /*
        This reset the visual validity of coupon input field to normal state
    */
    removePromoCodeValidation() {
        this.promoCodeWrapper.classList.remove('error', 'valid');
        this.promoCodeLabel.classList.remove('error', 'valid');
        this.couponErrorContainer.setAttribute('hidden', true);
        this.couponMissingError.setAttribute('hidden', true);
        this.couponErrorMessage.setAttribute('hidden', true);
        this.couponFieldReductionAmount.innerHTML = '';
    }

    /*
     This calls the Cart-RemoveCoupon SFRA Endpoint
    */
    removeCoupon(e) {
        // urlUtils.getCurrentOrigin() make sure url is valid for URL interface
        // as there's no protocol/origin in the data passed by the backend
        const url = new URL(urlUtils.getCurrentOrigin() + e.currentTarget.dataset.action);

        url.searchParams.append('code', e.currentTarget.dataset.code);
        url.searchParams.append('uuid', e.currentTarget.dataset.uuid);

        fetch(url.toString(), {
            method: 'GET',
        }).then((response) => response.json()).then((data) => {
            if (!data.valid.error) {
                document.dispatchEvent(new CustomEvent('mAjaxForm:clearFormMessage'));
            }
            this.cartTotals.couponsAndPromos.innerHTML = data.totals.discountsHtml; // this will remove the current selected coupon from DOM
            this.updateCartCounter(data);
            this.updateCartTotals(data);
            this.updateApproachingDiscounts(data.approachingDiscounts);
            this.validateBasket(data);
            this.removeCouponPopin.togglePopin(); // close the opened popin

            // if this was the last added coupon, clear the coupon input field
            if (document.querySelectorAll('.remove-coupon').length === 0) {
                this.couponCodeField.closest('.form-field').classList.remove('is-active');
                this.couponCodeField.value = '';
                this.removePromoCodeValidation();
            }
        });
    }

    onCloseMinicart(event) {
        if (event && event.detail && event.detail.sidebarId === 'o-sidebar-miniCart') {
            if (this.currentDyData) { // reset dyData to previous state
                dyHelpers.setDyRecommendationContext(this.currentDyData, true);
            }
        }
    }

    closeMiniCart() {
        const sidebar = this.closest('#o-sidebar-miniCart');
        if (sidebar) {
            sidebar.onCloseSlidebar();
        }
    }

    emptyMiniCart(emptyMiniCartHtml) {
        if (emptyMiniCartHtml) {
            window.currentDyData = this.currentDyData;
            this.outerHTML = emptyMiniCartHtml;
        }
    }

    addPaypalExpress() {
        const isPaypalAvailable = document.querySelector('#isPaypalAvailable');

        if (isPaypalAvailable && isPaypalAvailable.value === 'true') {
            // next line is ES2017 so it will throw an eslint error if you modify the file but don't worry
            (async () => {
                const adyenCheckoutExpress = await import(/* webpackChunkName: "adyenCheckoutExpress" */ 'customPaypalExpressFE/adyenCheckoutExpress');
                adyenCheckoutExpress.renderGenericComponent();
                this.paypalExpressButton = this.querySelector('#paymentMethodsList');
            })();
        }
    }

    addEventPromoSubmit() {
        if (!this.promoForm) return;

        const submitButton = this.promoForm.querySelector('.promocode-btn');

        domFunctions.onEvent(submitButton, 'click', (e) => {
            this.promoForm = this.querySelector('[data-component-promo]');
            if (!this.promoForm) return;

            const { target } = e;

            const promoCodeForm = this.promoForm.querySelector('.form-control');
            const csrfInput = this.promoForm.querySelector("input[name*='csrf_token']");
            let csrfToken = null;

            if (csrfInput) {
                csrfToken = csrfInput.value;
            }

            if (!csrfToken) {
                return false;
            }

            if (!this.couponCodeField || !this.couponCodeField.value) {
                promoCodeForm.setAttribute('aria-describedby', 'missingCouponCode');
                this.couponMissingError.removeAttribute('hidden');
                this.setPromoCodeValidation(false);
                return false;
            }

            const urlParams = {
                couponCode: this.couponCodeField.value,
                csrf_token: csrfToken,
            };

            const url = urlUtils.appendToUrl(target.dataset.action, urlParams);

            fetch(url, {
                method: 'GET',
            }).then((response) => response.json()).then((data) => {
                if (data.error) {
                    promoCodeForm.setAttribute('aria-describedby', 'invalidCouponCode');
                    this.setPromoCodeValidation(false);
                    this.couponErrorMessage.removeAttribute('hidden');
                    this.couponMissingError.setAttribute('hidden', true);
                    domFunctions.replaceHtml(this.couponErrorMessage, data.errorMessage);
                    if (this.promoCodeWrapper) this.promoCodeWrapper.classList.add('error');
                    if (this.promoCodeLabel) this.promoCodeLabel.classList.add('error');
                    this.couponFieldReductionAmount.innerHTML = '';
                } else {
                    if (data.valid.error) {
                        // Coupon added but basket is not valid
                        promoCodeForm.setAttribute('aria-describedby', 'invalidCouponCode');
                        this.setPromoCodeValidation(false);
                        this.couponErrorMessage.removeAttribute('hidden');
                        domFunctions.replaceHtml(this.couponErrorMessage, data.valid.message);
                    } else {
                        this.couponErrorContainer.setAttribute('hidden', true);
                        this.setPromoCodeValidation(true);
                        if (data.couponReduction) {
                            this.couponFieldReductionAmount.innerHTML = data.couponReduction;
                        }
                    }
                    this.cartTotals.couponsAndPromos.innerHTML = data.totals.discountsHtml;
                    this.updateCartCounter(data);
                    this.updateCartTotals(data);
                    this.updateApproachingDiscounts(data.approachingDiscounts);
                    this.validateBasket(data);
                }
            });
            return true;
        });

        domFunctions.onEvent(this.promoCodeField, 'keydown', (e) => {
            this.removePromoCodeValidation();

            if (e.code === 'Enter') {
                e.preventDefault();
                submitButton.dispatchEvent(new Event('click'));
            }
        });
    }

    updateTax() {
        const field = document.getElementById('cart-form-postalCode');
        let url = field.dataset.updateTaxUrl;
        const postalCode = field.value;

        if (url && postalCode) {
            url += `?postalCode=${postalCode}`;
            fetch(url, {
                method: 'GET',
            }).then((response) => response.json()).then((data) => {
                domFunctions.replaceHtml(this.couponsAndPromos, data.totals.discountsHtml);
                this.updateCartCounter(data);
                this.updateCartTotals(data);
                this.updateApproachingDiscounts(data.approachingDiscounts);
                this.validateBasket(data);
                if (this.paypalCheckButton.length) {
                    this.paypalCheckButton.forEach((paypalCheckButton) => {
                        paypalCheckButton.classList.add('d-none');
                    });
                    this.error.textContent = '';
                }
                if (this.paypalExpressButton) {
                    this.paypalExpressButton.classList.remove('d-none');
                    const paypalButtonLocations = this.querySelectorAll('.paypal-location');
                    paypalButtonLocations.forEach((paypalButtonLocation) => {
                        paypalButtonLocation.classList.remove('d-none');
                    });
                }
            });
        }
    }

    addEventPostalCodeTax() {
        const postalCodeField = document.querySelector('[cart-postal-code-form]');
        if (postalCodeField) {
            domFunctions.onEvent(postalCodeField, 'keydown', (e) => {
                if (e.code === 'Enter') {
                    e.preventDefault();
                    domFunctions.triggerEvent(e.target, new Event('focusout'));
                }
            });
            const postalCodeBtn = document.querySelector('.updatetax-btn');
            domFunctions.onEvent(postalCodeBtn, 'click', () => {
                // check is-invalid to validate good format
                const divWrapper = postalCodeField.closest('.input-wrapper');
                if (!divWrapper.classList.contains('error')) {
                    this.updateTax();
                }
            });
        }
    }

    // Add Event Listeners for each products in cart (change of quantity/size and deletion)
    addEventsProductLineItems() {
        this.productLineItems.forEach((pli) => {
            const removeButton = pli.querySelector('[data-component-remove-product]');
            domFunctions.onEvent(removeButton, 'click', (e) => {
                e.preventDefault();
                this.productToDelete.uuid = removeButton.dataset.uuid;
                this.productToDelete.pid = pli.dataset.pid;
                this.productToDelete.actionUrl = removeButton.dataset.action;
                this.makeRemoveProductModal();
            });

            const selectors = pli.querySelectorAll('cart-selector');
            selectors.forEach((selector) => {
                domFunctions.onEvent(selector, 'change', () => {
                    const url = selector.options[selector.selectedIndex] && selector.options[selector.selectedIndex].dataset.url;
                    window.location.href = url;
                });
            });

            this.addEventQuantitySelector(pli);
            this.addEventEditProduct(pli);
        });
    }

    // Add Event Listener for shipping method modification
    addEventShippingMethods() {
        this.shippingMethods.forEach((sm) => {
            domFunctions.onEvent(sm, 'change', (e) => {
                if (e && e.detail && e.detail.validFormEvent) {
                    return;
                }
                const selectedElem = e.target;
                const selectedId = selectedElem.dataset.shippingId;
                const urlParams = {
                    methodID: selectedId,
                };
                const url = urlUtils.appendToUrl(selectedElem.dataset.actionUrl, urlParams);

                domFunctions.triggerEvent('body', 'cart:beforeShippingMethodSelected');
                fetch(url, {
                    method: 'POST',
                    body: {},
                }).then((response) => response.json()).then((data) => {
                    if (data.error) {
                        if (data.redirectUrl) {
                            window.location.href = data.redirectUrl;
                        } else {
                            // ERROR MESSAGE
                        }
                    } else {
                        domFunctions.replaceHtml(this.couponsAndPromos, data.totals.discountsHtml);
                        this.updateCartCounter(data);
                        this.updateCartTotals(data);
                        this.updateApproachingDiscounts(data.approachingDiscounts);
                        this.validateBasket(data);
                    }
                    domFunctions.triggerEvent('body', 'cart:shippingMethodSelected', data);
                });
            });
        });
    }

    updateRecommendationContext(dyData) {
        if (this.isMinicart) {
            const dyDataInput = this.querySelector('[name="dyData"]');
            if (dyDataInput) {
                dyDataInput.value = dyData;
                dyHelpers.setDyRecommendationContext();
            }
        }
    }

    // Add Event Listener for change of size of a product (pli is a product line item)
    addEventEditProduct(pli) {
        const sizeSelector = pli.querySelector('[data-component-size]');
        const sizeSelectorHidden = pli.querySelector('[data-component-size-hidden]');
        domFunctions.onEvent(sizeSelector, 'change', () => {
            const { preSelectSize } = sizeSelector.dataset;
            const sizeSelected = sizeSelectorHidden.querySelector(`[value="${sizeSelector.value}"]`);
            const size = sizeSelected.dataset.sizeId;
            const productID = pli.dataset.pid;
            let url = sizeSelector.dataset.action;
            const { uuid } = sizeSelector.dataset;

            const urlParams = {
                pid: productID,
                size,
                uuid,
            };
            url = urlUtils.appendToUrl(url, urlParams);

            domFunctions.triggerEvent('body', 'cart:beforeUpdate');
            fetch(url, {
                method: 'GET',
            }).then((response) => response.json()).then((data) => {
                if (data.error || data.errorMessage) {
                    if (data.redirectUrl) {
                        window.location.href = data.redirectUrl;
                    } else {
                        // ERROR MESSAGE
                        sizeSelector.value = preSelectSize;
                    }
                    return;
                }
                if (data.toBeModified) {
                    let pliToModify;
                    // Check if the size selected represents a product already in the cart, if that is the case, we remove the product line item
                    // and we modify the quantity of the existing pli. Else, we modify the quandity, the size and pid relative information of actual pli
                    if (uuid !== data.toBeModified.uuid) {
                        domFunctions.removeNode(pli);
                        pliToModify = this.querySelector(`.uuid-${data.toBeModified.uuid}`);
                    } else {
                        pliToModify = pli;
                    }
                    if (pliToModify) {
                        pliToModify.dataset.pid = data.toBeModified.pid;

                        const quantitySelector = pliToModify.querySelector('[data-component-quantity]');
                        quantitySelector.value = data.toBeModified.quantity;
                        quantitySelector.dataset.preSelectQty = data.toBeModified.quantity;
                        resizeQuantityOptions(quantitySelector, data.toBeModified.maxQuantity);
                        quantitySelector.disabled = data.toBeModified.maxQuantity <= 1;

                        const sizeSelectorToModify = pliToModify.querySelector('[data-component-size]');
                        pliToModify.querySelectorAll('a[href]').forEach((link) => {
                            link.href = link.href.replace(productID, data.toBeModified.pid);
                        });
                        sizeSelectorToModify.dataset.preSelectSize = size;
                    }
                }
                domFunctions.replaceHtml(this.cartTotals.couponsAndPromos, data.basket.totals.discountsHtml);
                this.updateCartCounter(data.basket);
                this.updateCartTotals(data.basket);
                this.updateApproachingDiscounts(data.basket.approachingDiscounts);
                this.updateAvailability(data.basket, data.toBeModified.uuid);
                this.validateBasket(data.basket);

                if (data.gtmData && data.gtmData.length) {
                    for (const gtmEvent of data.gtmData) {
                        if (gtmEvent.event === 'add_to_cart') {
                            gtmEvent.add_to_cart_type = 'Cart';
                        }
                        document.dispatchEvent(new CustomEvent('gtm:pushEvent', {
                            detail: {
                                data: gtmEvent,
                            },
                        }));
                    }
                }

                this.updateRecommendationContext(data.dyData);

                domFunctions.triggerEvent('body', 'cart:update', data.basket);
            });
        });
    }

    // Add Event Listener for change of quantity of a product
    addEventQuantitySelector(pli) {
        const qtySelector = pli.querySelector('[data-component-quantity]');
        domFunctions.onEvent(qtySelector, 'change', () => {
            const { preSelectQty } = qtySelector.dataset;
            const quantity = qtySelector.value;
            const productID = pli.dataset.pid;
            let url = qtySelector.dataset.action;
            const { uuid } = qtySelector.dataset;
            const addToCart = quantity > preSelectQty;

            const urlParams = {
                pid: productID,
                quantity,
                uuid,
            };
            url = urlUtils.appendToUrl(url, urlParams);

            domFunctions.triggerEvent('body', 'cart:beforeUpdate');
            fetch(url, {
                method: 'GET',
            }).then((response) => response.json()).then((data) => {
                if (data.error || data.errorMessage) {
                    if (data.redirectUrl) {
                        window.location.href = data.redirectUrl;
                    } else {
                        // ERROR MESSAGE
                        qtySelector.value = preSelectQty;
                    }
                    return;
                }
                qtySelector.value = quantity;
                domFunctions.replaceHtml(this.cartTotals.couponsAndPromos, data.totals.discountsHtml);
                this.updateCartCounter(data);
                this.updateCartTotals(data);
                this.updateApproachingDiscounts(data.approachingDiscounts);
                this.updateAvailability(data, uuid);
                this.validateBasket(data);
                qtySelector.dataset.preSelectQty = quantity;

                domFunctions.triggerEvent('body', 'cart:update', data);

                if (pli.classList.contains('bonus-product-line-item') && !this.isMinicart) {
                    location.reload();
                }

                if (data.gtmData && data.gtmData.eventData) {
                    const eventsToSend = [];
                    const { eventData } = data.gtmData;
                    const event = {
                        data: eventData,
                        attributes: {
                            page_type: this.isMinicart ? 'Cart Panel' : eventData.page_type,
                        },
                    };
                    if (addToCart) {
                        event.attributes.add_to_cart_type = 'Cart';
                    }
                    eventsToSend.push(event);
                    if (data.gtmData.cartUpdatedData) {
                        eventsToSend.push({
                            data: data.gtmData.cartUpdatedData,
                            attributes: {
                                page_type: this.isMinicart ? 'Cart Panel' : eventData.page_type,
                            },
                        });
                    }

                    document.dispatchEvent(new CustomEvent('gtm:pushEvents', {
                        detail: {
                            events: eventsToSend,
                        },
                    }));
                }
            });
        });
    }

    deleteProduct(pid) {
        const product = this.querySelector(`[is="m-product-card"][data-pid="${pid}"]`);
        if (product) {
            this.productToDelete.pid = pid;
            this.productToDelete.uuid = product.dataset.uuid;
            this.productToDelete.actionUrl = product.dataset.removeAction;
            this.onDeleteProduct();
        }
    }

    onDeleteProduct() {
        const urlParams = {
            pid: this.productToDelete.pid,
            uuid: this.productToDelete.uuid,
        };

        const url = urlUtils.appendToUrl(this.productToDelete.actionUrl, urlParams);
        // CART BEFORE UPDATE
        fetch(url, {
            method: 'GET',
        }).then((response) => response.json()).then((data) => {
            if (data.error || data.errorMessage) {
                if (data.redirectUrl) {
                    window.location.href = data.redirectUrl;
                } else {
                    // TODO: ERROR MESSAGE
                    console.log('ERROR in server');
                }
                return;
            }
            this.updateCartCounter(data.basket);

            if (data.gtmData) {
                if (data.gtmData.eventData) {
                    document.dispatchEvent(new CustomEvent('gtm:pushEvent', {
                        detail: {
                            data: data.gtmData.eventData,
                            attributes: {
                                page_type: this.isMinicart ? 'Cart Panel' : data.gtmData.page_type,
                            },
                            pageType: !this.isMinicart,
                        },
                    }));
                }
            }

            if (data.basket.items.length === 0) {
                if (this.isMinicart && data.emptyMiniCartHtml) {
                    this.emptyMiniCart(data.emptyMiniCartHtml);
                } else {
                    window.location.href = data.homeRedirectUrl;
                }
                return;
            } if (data.gtmData && data.gtmData.cartUpdatedData) {
                document.dispatchEvent(new CustomEvent('gtm:pushEvent', {
                    detail: {
                        data: data.gtmData.cartUpdatedData,
                        attributes: {
                            page_type: this.isMinicart ? 'Cart Panel' : data.gtmData.page_type,
                        },
                        pageType: !this.isMinicart,
                    },
                }));
            }

            if (data.toBeDeletedUUIDs && data.toBeDeletedUUIDs.length) {
                for (const toBeDeletedUUID of data.toBeDeletedUUIDs) {
                    const uuidToRemove = this.querySelector(`.uuid-${toBeDeletedUUID}`);
                    if (uuidToRemove) {
                        domFunctions.removeNode(uuidToRemove.parentElement && uuidToRemove.parentElement.classList.contains('product-card-item') ? uuidToRemove.parentElement : uuidToRemove);
                    }
                }
            }

            const product = this.querySelector(`.uuid-${this.productToDelete.uuid}`);
            domFunctions.removeNode(product && product.parentElement && product.parentElement.classList.contains('product-card-item') ? product.parentElement : product);
            if (!data.basket.hasBonusProduct && this.bonusProduct) {
                domFunctions.removeNode(this.bonusProduct.parentElement && this.bonusProduct.parentElement.classList.contains('product-card-item') ? this.bonusProduct.parentElement : this.bonusProduct);
            }
            domFunctions.replaceHtml(this.cartTotals.couponsAndPromos, data.basket.totals.discountsHtml);
            this.updateProductListSections();
            this.updateCartTotals(data.basket);
            this.updateApproachingDiscounts(data.basket.approachingDiscounts);
            domFunctions.triggerEvent('body', 'setShippingMethodSelection', data.basket);
            this.validateBasket(data.basket);
            this.updateRecommendationContext(data.dyData);
        });
    }

    addEventPromoForm() {

    }

    updateProductListSections() {
        Object.values(this.productListSections).forEach((productListSection) => {
            if (!productListSection) {
                return;
            }
            const productList = productListSection.querySelector('[is="m-product-card-list"]');
            if (!productList || productList.children.length === 0) {
                domFunctions.removeNode(productListSection);
            }
        });
    }

    updateAvailability(data, uuid) {
        let lineItem;
        let messages = '';

        for (let i = 0; i < data.items.length; i++) {
            if (data.items[i].UUID === uuid) {
                lineItem = data.items[i];
                break;
            }
        }

        if (lineItem !== null) {
            const availability = this.querySelector(`.availability-${lineItem.UUID}`);

            if (lineItem.availability) {
                if (lineItem.availability.messages) {
                    lineItem.availability.messages.forEach((message) => {
                        messages += `<p class="line-item-attributes">${message}</p>`;
                    });
                }

                if (lineItem.availability.inStockDate) {
                    messages += `<p class="line-item-attributes line-item-instock-date">${
                        lineItem.availability.inStockDate
                    }</p>`;
                }
            }

            domFunctions.replaceHtml(availability, messages);
        }
    }

    updateCartTotals(data) {
        domFunctions.replaceHtml(this.cartTotals.numberOfItems, data.resources.numberOfItems);
        this.cartTotals.shippingCost.forEach((costElem) => {
            domFunctions.replaceHtml(
                costElem,
                data.totals.totalShippingCostValue === 0 ? data.resources.offeredMessage : data.totals.totalShippingCost,
            );
        });
        domFunctions.replaceHtml(this.cartTotals.taxTotal, data.totals.totalTax);
        domFunctions.replaceHtml(this.cartTotals.grandTotal, data.totals.grandTotal);
        domFunctions.replaceHtml(this.cartTotals.subTotal, data.totals.subTotal);

        if (data.totals.orderLevelDiscountTotal.value > 0) {
            domFunctions.removeClass(this.cartTotals.orderDiscount, 'hide-order-discount');
            domFunctions.replaceHtml(this.cartTotals.orderDiscountTotal, `- ${data.totals.orderLevelDiscountTotal.formatted}`);
        } else {
            domFunctions.addClass(this.cartTotals.orderDiscount, 'hide-order-discount');
        }

        if (data.totals.shippingLevelDiscountTotal.value > 0) {
            domFunctions.removeClass(this.cartTotals.shippingDiscount, 'hide-shipping-discount');
            domFunctions.replaceHtml(this.cartTotals.shippingLevelDiscountTotal, `- ${data.totals.shippingLevelDiscountTotal.formatted}`);
        } else {
            domFunctions.addClass(this.cartTotals.shippingDiscount, 'hide-shipping-discount');
        }

        data.items.forEach((item) => {
            if (data.totals.orderLevelDiscountTotal.value > 0) {
                domFunctions.replaceHtml(this.couponsAndPromos, data.totals.discountsHtml);
            }
            const lineItem = this.querySelector(`.item-${item.UUID}`);
            if (item.renderedPromotions) {
                domFunctions.replaceHtml(lineItem, item.renderedPromotions);
            } else {
                domFunctions.emptyNode(lineItem);
            }
            const itemUnitPrice = this.querySelector(`.uuid-${item.UUID} .unit-price`);
            const lineItemUnitPrice = this.querySelector(`.line-item-price-${item.UUID} .unit-price`);
            const itemTotal = this.querySelector(`.item-total-${item.UUID}`);
            const quantity = this.querySelector(`.uuid-${item.UUID} .qty-card-quantity-count`);

            domFunctions.replaceHtml(itemUnitPrice, item.renderedPrice);
            domFunctions.replaceHtml(lineItemUnitPrice, item.renderedPrice);
            domFunctions.replaceHtml(itemTotal, item.priceTotal.renderedPrice);
            domFunctions.replaceHtml(quantity, item.quantity);
        });
    }

    updateApproachingDiscounts(approachingDiscounts) {
        let html = '';
        if (approachingDiscounts.length) {
            approachingDiscounts.forEach((item) => { // TODO: Maybe modify
                html += `<div class="single-approaching-discount text-center">${
                    item.discountMsg}</div>`;
            });
        }
        domFunctions.replaceHtml(this.cartTotals.approachingDiscounts, html);
    }

    updateCartCounter(basket) {
        document.dispatchEvent(new CustomEvent('oNavigation:updateCartCount', {
            detail: {
                productCount: basket.numItems,
            },
        }));
    }

    validateBasket(data) {
        if (data.valid.error) {
            if (data.valid.message) {
                domFunctions.replaceHtml(this.error, data.valid.message);
            } else {
                this.closeMiniCart();
            }
            domFunctions.addClass(this.checkoutBtn, 'disabled');
        } else {
            domFunctions.removeClass(this.checkoutBtn, 'disabled');
        }
    }

    bindMobileUpperBtnToLowerBtn() {
        if (this.mobileUpperCartBtn) {
            this.mobileUpperCartBtn.addEventListener('click', () => {
                if (!this.checkoutBtn.disabled) {
                    this.checkoutBtn.click();
                }
            });
        }
    }
}

customElements.define('o-cart', oCart, {
    extends: 'div',
});
